var React = require('react');

function Apple (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m19.041 14.875a6.189 6.189 0 0 0 3.759 5.666 15.322 15.322 0 0 1 -1.939 3.983c-1.168 1.706-2.378 3.405-4.286 3.44-1.875.036-2.475-1.112-4.622-1.112s-2.812 1.077-4.587 1.148c-1.842.07-3.244-1.845-4.421-3.544-2.404-3.478-4.245-9.825-1.774-14.109a6.854 6.854 0 0 1 5.794-3.507c1.808-.034 3.516 1.217 4.621 1.217s3.179-1.5 5.36-1.283a6.541 6.541 0 0 1 5.121 2.777 6.332 6.332 0 0 0 -3.026 5.327m-3.526-10.407a6.167 6.167 0 0 0 1.458-4.471 6.277 6.277 0 0 0 -4.125 2.122 5.86 5.86 0 0 0 -1.485 4.329 5.193 5.193 0 0 0 4.152-1.98","fill":"#fff"}));
}

Apple.defaultProps = {"height":"28","viewBox":"0 0 22.8 28","width":"22.8"};

module.exports = Apple;

Apple.default = Apple;
